module.exports = __webpack_public_path__ + "img/04-02_Demonstrating Empathy.aaedc1c9.svg";